export var ICONS;
(function (ICONS) {
    ICONS["accordionDown"] = "accordion-down";
    ICONS["accordionUp"] = "accordion-notdown";
    ICONS["add"] = "add";
    ICONS["addDevice"] = "add-device";
    ICONS["addGroup"] = "add-group";
    ICONS["addGuidance"] = "add-guidance";
    ICONS["addShare"] = "add-share";
    ICONS["addToCart"] = "add-to-cart";
    ICONS["addWidget"] = "add-widget";
    ICONS["alarm"] = "alarm";
    ICONS["analysis"] = "analysis";
    ICONS["analysis1"] = "analysis-1";
    ICONS["apps"] = "apps";
    ICONS["area"] = "area";
    ICONS["areaPolygon"] = "area-polygon";
    ICONS["arrowDown"] = "arrow-down";
    ICONS["arrowLeft"] = "arrow-left";
    ICONS["arrowLeftDown"] = "arrow-left-down";
    ICONS["arrowRight"] = "arrow-right";
    ICONS["arrowRightUp"] = "arrow-right-up";
    ICONS["arrowUp"] = "arrow-up";
    ICONS["arrow2Down"] = "arrow2-down";
    ICONS["arrow2Down1"] = "arrow2-down-1";
    ICONS["arrow2Left"] = "arrow2-left";
    ICONS["arrow2Left1"] = "arrow2-left-1";
    ICONS["arrow2Right"] = "arrow2-right";
    ICONS["arrow2Right1"] = "arrow2-right-1";
    ICONS["arrow2Up"] = "arrow2-up";
    ICONS["arrow2Up1"] = "arrow2-up-1";
    ICONS["assign"] = "assign";
    ICONS["bands"] = "bands";
    ICONS["biophysicalYield"] = "biophysical-yield";
    ICONS["buffer"] = "buffer";
    ICONS["byProduct"] = "by-product";
    ICONS["calendar"] = "calendar";
    ICONS["cancel"] = "cancel";
    ICONS["canBus"] = "can-bus";
    ICONS["canBusParameter"] = "can-bus-parameter";
    ICONS["cart"] = "cart";
    ICONS["check"] = "check";
    ICONS["checkboxPartial"] = "checkbox-partial";
    ICONS["checkboxSelected"] = "checkbox-selected";
    ICONS["checkboxUnselected"] = "checkbox-unselected";
    ICONS["chevronLeft"] = "chevron-left";
    ICONS["chevronRight"] = "chevron-right";
    ICONS["circleArrowDown"] = "circle-arrow-down";
    ICONS["circleArrowRight"] = "circle-arrow-right";
    ICONS["circleArrowUp"] = "circle-arrow-up";
    ICONS["circleCancel"] = "circle-cancel";
    ICONS["circleCheck"] = "circle-check";
    ICONS["circleTime"] = "circle-time";
    ICONS["clorophyllVigorPigment"] = "clorophyll-vigor-pigment";
    ICONS["close"] = "close";
    ICONS["close2"] = "close2";
    ICONS["colorComposer"] = "color-composer";
    ICONS["combinedShape"] = "combined-shape";
    ICONS["concentrate"] = "concentrate";
    ICONS["cow"] = "cow";
    ICONS["creditCard"] = "credit-card";
    ICONS["dataset"] = "dataset";
    ICONS["delete"] = "delete";
    ICONS["digitalInput"] = "digital-input";
    ICONS["display"] = "display";
    ICONS["download"] = "download";
    ICONS["dr"] = "dr";
    ICONS["dr1"] = "dr-1";
    ICONS["drag"] = "drag";
    ICONS["edit"] = "edit";
    ICONS["eye"] = "eye";
    ICONS["eyeCanceled"] = "eye-canceled";
    ICONS["farm"] = "farm";
    ICONS["feedGroup"] = "feed-group";
    ICONS["feedback"] = "feedback";
    ICONS["fertilizer"] = "fertilizer";
    ICONS["field"] = "field";
    ICONS["file"] = "file";
    ICONS["filter"] = "filter";
    ICONS["foodDelivery"] = "food-delivery";
    ICONS["foodProducts"] = "food-products";
    ICONS["format"] = "format";
    ICONS["freshGrass"] = "fresh-grass";
    ICONS["geofence"] = "geofence";
    ICONS["goTo"] = "go-to";
    ICONS["graph"] = "graph";
    ICONS["grower"] = "grower";
    ICONS["guidance"] = "guidance";
    ICONS["hamburger"] = "hamburger";
    ICONS["import"] = "import";
    ICONS["informations"] = "informations";
    ICONS["ingredients"] = "ingredients";
    ICONS["layers"] = "layers";
    ICONS["logout"] = "logout";
    ICONS["machine"] = "machine";
    ICONS["machineUpload"] = "machine-upload";
    ICONS["manage"] = "manage";
    ICONS["medication"] = "medication";
    ICONS["mineral"] = "mineral";
    ICONS["mixer"] = "mixer";
    ICONS["moistureBiomass"] = "moisture-biomass";
    ICONS["more"] = "more";
    ICONS["nitrogen"] = "nitrogen";
    ICONS["partners"] = "partners";
    ICONS["pdf"] = "pdf";
    ICONS["period"] = "period";
    ICONS["phone"] = "phone";
    ICONS["plus"] = "plus";
    ICONS["powerManagement"] = "power-management";
    ICONS["premix"] = "premix";
    ICONS["prescription"] = "prescription";
    ICONS["profile"] = "profile";
    ICONS["profileNotSelected"] = "profile-not-selected";
    ICONS["proteinComponents"] = "protein-components";
    ICONS["quote"] = "quote";
    ICONS["radioSelected"] = "radio-selected";
    ICONS["radioUnselected"] = "radio-unselected";
    ICONS["recipe"] = "recipe";
    ICONS["reset"] = "reset";
    ICONS["roughage"] = "roughage";
    ICONS["rtf"] = "rtf";
    ICONS["scrollDown"] = "scroll-down";
    ICONS["search"] = "search";
    ICONS["searchLocation"] = "search-location";
    ICONS["settings"] = "settings";
    ICONS["share"] = "share";
    ICONS["share2"] = "share2";
    ICONS["socialFacebook"] = "social-facebook";
    ICONS["socialLinkedln"] = "social-linkedln";
    ICONS["socialYoutube"] = "social-youtube";
    ICONS["spinner"] = "spinner";
    ICONS["starEmpty"] = "star-empty";
    ICONS["starFill"] = "star-fill";
    ICONS["status"] = "status";
    ICONS["stress"] = "stress";
    ICONS["subscriptions"] = "subscriptions";
    ICONS["support"] = "support";
    ICONS["task"] = "task";
    ICONS["tasks"] = "tasks";
    ICONS["temperature"] = "temperature";
    ICONS["thematization"] = "thematization";
    ICONS["undo"] = "undo";
    ICONS["upload"] = "upload";
    ICONS["warehouse"] = "warehouse";
    ICONS["warning"] = "warning";
    ICONS["warning2"] = "warning-2";
    ICONS["windspeed"] = "windspeed";
    ICONS["xls"] = "xls";
    ICONS["zip"] = "zip";
    ICONS["zone"] = "zone";
})(ICONS || (ICONS = {}));
export const iconList = Object.values(ICONS);
//# sourceMappingURL=icons.js.map